import { useCallback, MouseEventHandler, useRef } from "react";

interface IUseClickHandler {
  onTap: (clicks: number) => void;
  isHolding: React.MutableRefObject<boolean>;
}

type EmptyCallback = () => void;

type CallbackFunction<Target = Element> = MouseEventHandler<Target> | EmptyCallback;

const DEFAULT_THRESHOLD = 500;

export const useClickHandler = ({ onTap, isHolding }: IUseClickHandler) => {
  const clickCount = useRef<number>(0);
  const timer = useRef<NodeJS.Timeout | null>(null);

  return useCallback<CallbackFunction<Element>>(() => {
    if (isHolding.current) {
      return;
    }

    clickCount.current += 1;

    if (!timer.current) {
      timer.current = setTimeout(() => {
        onTap(clickCount.current);
        timer.current = null;
        clickCount.current = 0;
      }, DEFAULT_THRESHOLD);
    }
  }, [onTap, isHolding]);
};
